import { render, staticRenderFns } from "./ToolsCard.vue?vue&type=template&id=20d40e84&scoped=true&"
import script from "./ToolsCard.vue?vue&type=script&lang=js&"
export * from "./ToolsCard.vue?vue&type=script&lang=js&"
import style0 from "./ToolsCard.vue?vue&type=style&index=0&id=20d40e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d40e84",
  null
  
)

export default component.exports